import Swal from 'sweetalert2';

/** Máximo de accesos fijados en el dock inferior (más de 9 colapsa la barra). */
export const MAX_BOTTOM_DOCK_PINS = 9;

/** Toast visible por encima del dock inferior (no usar bottom-end). */
export function fireBottomDockLimitAlert(maxPins = MAX_BOTTOM_DOCK_PINS) {
  Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'warning',
    title: `Barra completa (${maxPins}/${maxPins})`,
    text: 'Quitá un acceso de la barra para agregar otro.',
    showConfirmButton: false,
    timer: 3400,
    timerProgressBar: true,
    customClass: { popup: 'swal-toast-crm swal-toast-crm--dock-limit' },
    didOpen: () => {
      const container = Swal.getContainer();
      if (container) {
        container.style.zIndex = '2147482998';
        container.style.paddingTop = '14px';
      }
    }
  });
}
